import '../../stylus/components/_grid.styl'

import Grid from './grid'

export default Grid('flex')



// WEBPACK FOOTER //
// ./src/components/VGrid/VFlex.js